module.exports = new __parcel__URL__("quick-filters-app-skeleton.tpl.2d23d208.svg").toString();